module.exports = __webpack_public_path__ + "img/product_129.a821d4b.webp";